import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { Icon } from "leaflet";
import "./map.scss";
import "leaflet/dist/leaflet.css";
import { useContext} from "react";
import { Context } from "../../App";
import locationIcon from "../../images/icon-location.svg";
import ChangeMapView from "../cahngeView";
import { PuffLoader } from "react-spinners";

export default function Map() {
  const { data } = useContext(Context);

  const customIcon = new Icon({
    iconUrl: locationIcon,
    iconSize: [36, 36],
  });
  return (
    <div className="map">
      {data ? (
        <MapContainer center={[data.location.lat, data.location.lng]} zoom={13}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <ChangeMapView
            center={[data.location.lat, data.location.lng]}
            zoom={13}
          />
          <Marker
            position={[data.location.lat, data.location.lng]}
            icon={customIcon}
          ></Marker>
        </MapContainer>
      ) : (
        <div className="loader">
          <PuffLoader />
        </div>
      )}
    </div>
  );
}
